export const ONLINE_THRESHOLD_MS = 120_000

export type DeviceLiveness = 'online' | 'daemon-down' | 'offline' | 'never-seen'

function heartbeatFresh(at: string | null | undefined, now: number): boolean {
  return at != null && now - new Date(at).getTime() < ONLINE_THRESHOLD_MS
}

export function deviceLiveness(
  lastHeartbeatAt: string | null | undefined,
  lastUserAgentHeartbeatAt?: string | null | undefined,
  now: number = Date.now(),
): DeviceLiveness {
  if (heartbeatFresh(lastHeartbeatAt, now)) {
    return 'online'
  }
  if (heartbeatFresh(lastUserAgentHeartbeatAt, now)) {
    return 'daemon-down'
  }
  if (!lastHeartbeatAt) {
    return 'never-seen'
  }
  return 'offline'
}

export const TCC_MISS_THRESHOLD = 3

export type TccPermission = 'screen_recording' | 'accessibility'

export type TccMissCounts = Record<TccPermission, number>

const TCC_PERMISSIONS: readonly TccPermission[] = [
  'screen_recording',
  'accessibility',
]

export function permissionsNeedingAction(misses: TccMissCounts): TccPermission[] {
  return TCC_PERMISSIONS.filter((permission) => misses[permission] >= TCC_MISS_THRESHOLD)
}

export type CommandStatusTone = 'completed' | 'failed' | 'timeout' | 'delivered' | 'other'

export function commandStatusTone(status: string): CommandStatusTone {
  switch (status) {
    case 'completed':
    case 'failed':
    case 'timeout':
    case 'delivered':
      return status
    default:
      return 'other'
  }
}
